/** A datetime-local value has no timezone. Resolve it in the meeting's IANA
 * zone rather than the viewer's device zone. In a fall-back fold, use the
 * earlier occurrence; reject spring-forward gaps instead of moving the call. */
export function zonedDate(value, timeZone) {
    const match = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)$/.exec(value);
    if (!match)
        return new Date(NaN);
    const [, year, month, day, hour, minute] = match.map(Number);
    const wall = Date.UTC(year, month - 1, day, hour, minute);
    if (new Date(wall).toISOString().slice(0, 16) !== value)
        return new Date(NaN);
    const candidates = new Set();
    for (const delta of [-86400000, 0, 86400000]) {
        const probe = new Date(wall + delta);
        candidates.add(wall - zoneOffset(probe, timeZone) * 60000);
    }
    const matches = [...candidates].filter(ms => zonedLocal(new Date(ms), timeZone) === value);
    return new Date(Math.min(...matches));
}
function zoneOffset(date, timeZone) {
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone, year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
    }).formatToParts(date);
    const fields = Object.fromEntries(parts.map(p => [p.type, Number(p.value)]));
    return (Date.UTC(fields.year, fields.month - 1, fields.day, fields.hour, fields.minute, fields.second) -
        Math.floor(date.getTime() / 1000) * 1000) / 60000;
}
export function zonedLocal(date, timeZone) {
    if (!Number.isFinite(date.getTime()))
        return "";
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone, year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", hourCycle: "h23",
    }).formatToParts(date);
    const fields = Object.fromEntries(parts.map(p => [p.type, p.value]));
    return `${fields.year}-${fields.month}-${fields.day}T${fields.hour}:${fields.minute}`;
}
export function zoneLabel(date, timeZone) {
    if (!Number.isFinite(date.getTime()))
        return timeZone;
    const offset = zoneOffset(date, timeZone);
    const sign = offset < 0 ? "-" : "+";
    return `${timeZone} (UTC${sign}${String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0")}:${String(Math.abs(offset) % 60).padStart(2, "0")})`;
}
